// Author Liang Gang Qiang
// Date 2022-03-14 16:21:35

class SithMesPrdToolsRelateOperation {
constructor({
        id = null,
        operationId = '',
        operationSeq = '',
        toolsId = '',
        toolsName = '',
        quantity = '',
        startTime = '',
        endTime = '',
        status = '',
        type = '',
        actualStartTime = '',
        actualEndTime = '',
        receiveTime = '',
        receiveOperator = '',
        returnTime = '',
        returnOperator = '',
        remark = ''}
= {}) {
    this.id = id;
    this.operationId = operationId;
    this.operationSeq = operationSeq;
    this.toolsId = toolsId;
    this.toolsName = toolsName;
    this.quantity = quantity;
    this.startTime = startTime;
    this.endTime = endTime;
    this.status = status;
    this.type = type;
    this.actualStartTime = actualStartTime;
    this.actualEndTime = actualEndTime;
    this.receiveTime = receiveTime;
    this.receiveOperator = receiveOperator;
    this.returnTime = returnTime;
    this.returnOperator = returnOperator;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdToolsRelateOperation();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'toolsCode',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.toolsCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'toolsName',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.toolsName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'toolsSize',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.toolsSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'pitchRow',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.pitchRow',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'specialDescription',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.specialDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'area',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.area',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'bin',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.bin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'headerOrderCode',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.headerOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'operationSeq',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.operationSeq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'quantity',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.quantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'startTime',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.startTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'endTime',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.endTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'status',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.status',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '未确认' },
                            { value: '2', text: '确认收到' },
                            { value: '3', text: '确认还回' }
            ]
        }
        },
        {
        key: 'receiveTime',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.receiveTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'receiveOperator',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.receiveOperator',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'returnTime',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.returnTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'returnOperator',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.returnOperator',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    operationIdFilter : '',
    operationSeqFilter : '',
    toolsIdFilter : '',
    toolsNameFilter : '',
    toolsIdListFilter : [],
    quantityFilter : '',
    startTimeRteFilter : '',
    startTimeLteFilter : '',
    endTimeRteFilter : '',
    endTimeLteFilter : '',
    statusFilter : '',
    typeFilter : '',
    actualStartTimeRteFilter : '',
    actualStartTimeLteFilter : '',
    actualEndTimeRteFilter : '',
    actualEndTimeLteFilter : '',
    receiveTimeRteFilter : '',
    receiveTimeLteFilter : '',
    receiveOperatorFilter : '',
    returnTimeRteFilter : '',
    returnTimeLteFilter : '',
    returnOperatorFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'operationSeqFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.operationSeq',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'operationSeq'
            ,fieldsBindingByEntityModalSelected: '{"operationId":"id"}'
                }
        },
        {
        key: 'toolsNameFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.toolsName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdToolsInfo'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"toolsId":"id"}'
                }
        },
        {
        key: 'quantityFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.quantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.startTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.startTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'endTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.endTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'endTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.endTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.status',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '未确认' },
                { value: '2', text: '确认收到' },
                { value: '3', text: '确认还回' }
            ]
        }
        },
        {
        key: 'receiveTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.receiveTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'receiveTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.receiveTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'receiveOperatorFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.receiveOperator',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'returnTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.returnTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'returnTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.returnTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'returnOperatorFilter',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.filter.returnOperator',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'operationSeq',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.entity.operationSeq',
        sortable: true,
        disabled: true,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'operationSeq'
            ,fieldsBindingByEntityModalSelected: '{"operationId":"id"}'
                }
        },
        {
        key: 'toolsName',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.entity.toolsName',
        sortable: true,
        disabled: true,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdToolsInfo'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"toolsId":"id"}'
                }
        },
        {
        key: 'quantity',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTime',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'endTime',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.entity.endTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdToolsRelateOperation.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdToolsRelateOperation, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
